import { MasterConfigs } from "../../../../interfaces/entity";

export const RoleTitleConfig: MasterConfigs = {
  api: () => '/role',
  title: 'Role Title',
  isActionTab: true,
  modalTitle: (action) => `${action} ${RoleTitleConfig.title}`,
  getColumns: () => {
    return [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Department',
        dataIndex: 'department',
        key: 'department',
        render: (department) => {
          return department && department.name;
        },
      },
      {
        title: 'Applies To',
        dataIndex: 'appliesTo',
        key: 'appliesTo',
        width: 200,
        render: (appliesTo) => {
          return appliesTo
        },
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        width: 100,
        render: (item) => {
          return item ? 'Active' : 'Deactive';
        },
      },
      {
        title: 'Created On',
        dataIndex: 'createdAt',
        key: 'createdAt',
        width: 150,
        render: (date) => {
          return new Date(date).toDateString();
        }
      },
    ];
  },
  getFormColumns: () => {
    return [
      {
        label: 'Name',
        name: 'name',
        type: 'text',
        rules: [{ required: true, message: 'Name is required' }],
      },
      {
        label: 'Department',
        name: 'department',
        isCombo: true,
        type: 'select',
        rules: [{ required: true, message: 'Department is required' }],
      },
      {
        label: 'Description',
        name: 'description',
        type: 'textarea',
        span: 12,
        rules: [{ required: false, message: 'Description is required' }],
      },
    ];
  },
  combo: [
    {
      name: 'department',
      api: '/departments',
      idKey: '_id',
      render: (e) => e.name
    },
  ],
  getData: () => ({}),
  actions: [
    { name: 'Add Role', actionType: 'Add' }
  ],
};
